// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oGRKnZHWxo1TJILBX4JR {
	background-color: var(--gray);
	border-radius: 8px;
	border: 0;
	cursor: pointer;
	padding: 8px 12px;
}
.oGRKnZHWxo1TJILBX4JR:enabled:active {
		background-color: var(--black);
		color: var(--brand);
	}
`, "",{"version":3,"sources":["webpack://./src/components/MaxButton/MaxButton.pcss"],"names":[],"mappings":"AAAA;CACC,6BAA6B;CAC7B,kBAAkB;CAClB,SAAS;CACT,eAAe;CACf,iBAAiB;AAMlB;AAJC;EACC,8BAA8B;EAC9B,mBAAmB;CACpB","sourcesContent":[".container {\n\tbackground-color: var(--gray);\n\tborder-radius: 8px;\n\tborder: 0;\n\tcursor: pointer;\n\tpadding: 8px 12px;\n\n\t&:enabled:active {\n\t\tbackground-color: var(--black);\n\t\tcolor: var(--brand);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `oGRKnZHWxo1TJILBX4JR`
};
export default ___CSS_LOADER_EXPORT___;
